import styled from 'styled-components';
import { Paragraph } from './Text';


const StyledCheckboxContainer = styled.label`
    cursor: pointer;
    display: flex;
    align-items: center;

    & span:not(:last-child) {
        margin-right: 8px;
    }
`;

const StyledCheckboxWrapper = styled.span`
    position: relative;
    width: 16px;
    height: 16px;

    input:checked ~ span {
        background-color: #2378FF;
        border: none;
    }

    & input:checked ~ span:after {
        display: block;
    }

    & span:after {
        left: 4px;
        top: 1px;
        width: 7px;
        height: 10px;
        border: solid white;
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
`;

const StyledCheckbox = styled.input.attrs({
    type: "checkbox"
})`
    appearance: none;
`;

const StyledCheckmark = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 2px solid #E4EDFD;
    border-radius: 2px;
    background: #FFFFFF;

    &:after {
        content: "";
        position: absolute;
        display: none;
    }
`;

export const Checkbox = ({onChange, checked, ...props}) => (
    <StyledCheckboxContainer>
        <StyledCheckboxWrapper>
            <StyledCheckbox onChange={onChange} checked={checked} />
            <StyledCheckmark />
        </StyledCheckboxWrapper>
        {typeof props.children === "string" ? <Paragraph>{props.children}</Paragraph> : props.children}
    </StyledCheckboxContainer>
);